export default __webpack_public_path__ + "d07b0bfcb1aa6c43d9e970930fa09905.png";